import React, { useState } from "react";
import {
  ClipboardList,
  ClipboardCheck,
  AlertTriangle,
  KeyRound,
} from "lucide-react";
import { theme } from "../../../shared/styles/theme";

interface ModalSenhaTemporariaProps {
  senha: string;
  email: string;
  onClose: () => void;
}

export default function ModalSenhaTemporaria({
  senha,
  email,
  onClose,
}: ModalSenhaTemporariaProps) {
  const [copiado, setCopiado] = useState(false);

  const handleCopiar = () => {
    navigator.clipboard.writeText(senha);
    setCopiado(true);
    setTimeout(() => setCopiado(false), 2000);
  };

  const handleCopiarCredenciais = () => {
    const credenciais = `Email: ${email}\nSenha: ${senha}`;
    navigator.clipboard.writeText(credenciais);
    setCopiado(true);
    setTimeout(() => setCopiado(false), 2000);
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0, 0, 0, 0.7)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
        padding: "20px",
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: "white",
          borderRadius: theme.borderRadius.xl,
          boxShadow: theme.shadows.xl,
          maxWidth: "500px",
          width: "100%",
          padding: "32px",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* ÍCONE E TÍTULO */}
        <div style={{ textAlign: "center", marginBottom: "24px" }}>
          <div
            style={{
              fontSize: "64px",
              marginBottom: "16px",
            }}
          >
            <KeyRound size={48} />
          </div>
          <h2
            style={{
              fontSize: "24px",
              fontWeight: "bold",
              color: theme.gray[800],
              margin: "0 0 8px 0",
              fontFamily: theme.fonts.sans,
            }}
          >
            Usuário Cadastrado!
          </h2>
          <p
            style={{
              fontSize: "14px",
              color: theme.gray[600],
              margin: 0,
              fontFamily: theme.fonts.sans,
            }}
          >
            Senha temporária gerada com sucesso
          </p>
        </div>

        {/* ALERTA IMPORTANTE */}
        <div
          style={{
            background: "#fef3c7",
            border: `2px solid #f59e0b`,
            borderRadius: theme.borderRadius.md,
            padding: "16px",
            marginBottom: "24px",
          }}
        >
          <div
            style={{
              display: "flex",
              gap: "12px",
              alignItems: "flex-start",
            }}
          >
            <AlertTriangle size={24} />
            <div>
              <p
                style={{
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#92400e",
                  margin: "0 0 4px 0",
                  fontFamily: theme.fonts.sans,
                }}
              >
                Atenção!
              </p>
              <p
                style={{
                  fontSize: "13px",
                  color: "#92400e",
                  margin: 0,
                  fontFamily: theme.fonts.sans,
                }}
              >
                Copie esta senha agora! Ela não será mostrada novamente. O
                usuário deverá trocar a senha no primeiro acesso.
              </p>
              <p
                style={{
                  fontSize: "12px",
                  color: "#92400e",
                  margin: "6px 0 0 0",
                  fontFamily: theme.fonts.sans,
                }}
              >
                🔒 Entregue a senha por <strong>canal seguro</strong> (pessoalmente
                ou por mensagem direta/criptografada) — evite e-mail aberto.
              </p>
            </div>
          </div>
        </div>

        {/* EMAIL */}
        <div style={{ marginBottom: "16px" }}>
          <label
            style={{
              display: "block",
              fontSize: "13px",
              fontWeight: "600",
              color: theme.gray[700],
              marginBottom: "8px",
              fontFamily: theme.fonts.sans,
            }}
          >
            Email:
          </label>
          <div
            style={{
              background: theme.gray[50],
              border: `1px solid ${theme.gray[300]}`,
              borderRadius: theme.borderRadius.md,
              padding: "12px 16px",
              fontSize: "14px",
              color: theme.gray[700],
              fontFamily: "monospace",
            }}
          >
            {email}
          </div>
        </div>

        {/* SENHA TEMPORÁRIA */}
        <div style={{ marginBottom: "24px" }}>
          <label
            style={{
              display: "block",
              fontSize: "13px",
              fontWeight: "600",
              color: theme.gray[700],
              marginBottom: "8px",
              fontFamily: theme.fonts.sans,
            }}
          >
            Senha Temporária:
          </label>
          <div
            style={{
              background: theme.primary[50],
              border: `2px solid ${theme.primary[300]}`,
              borderRadius: theme.borderRadius.md,
              padding: "16px",
              display: "flex",
              alignItems: "center",
              gap: "12px",
            }}
          >
            <div
              style={{
                flex: 1,
                fontSize: "20px",
                fontWeight: "bold",
                color: theme.primary[700],
                fontFamily: "monospace",
                letterSpacing: "2px",
              }}
            >
              {senha}
            </div>
            <button
              onClick={handleCopiar}
              style={{
                padding: "8px 16px",
                background: copiado ? "#10b981" : theme.primary[600],
                color: "white",
                border: "none",
                borderRadius: theme.borderRadius.md,
                fontSize: "13px",
                fontWeight: "600",
                cursor: "pointer",
                fontFamily: theme.fonts.sans,
                transition: "all 0.2s ease",
                whiteSpace: "nowrap",
              }}
            >
              {copiado ? (
                <>
                  <ClipboardCheck size={14} style={{ marginRight: "6px" }} />
                  Copiado!
                </>
              ) : (
                <>
                  <ClipboardList size={14} style={{ marginRight: "6px" }} />
                  Copiar
                </>
              )}
            </button>
          </div>
        </div>

        {/* BOTÕES */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "12px",
          }}
        >
          <button
            onClick={handleCopiarCredenciais}
            style={{
              width: "100%",
              padding: "14px",
              background: copiado ? "#10b981" : theme.primary[600],
              color: "white",
              border: "none",
              borderRadius: theme.borderRadius.md,
              fontSize: "15px",
              fontWeight: "600",
              cursor: "pointer",
              fontFamily: theme.fonts.sans,
              transition: "all 0.2s ease",
            }}
          >
            {copiado ? (
              <>
                <ClipboardCheck size={14} style={{ marginRight: "6px" }} />
                Credenciais Copiadas!
              </>
            ) : (
              <>
                <ClipboardList size={14} style={{ marginRight: "6px" }} />
                Copiar Email + Senha
              </>
            )}
          </button>

          <button
            onClick={onClose}
            style={{
              width: "100%",
              padding: "14px",
              background: theme.gray[200],
              color: theme.gray[700],
              border: "none",
              borderRadius: theme.borderRadius.md,
              fontSize: "15px",
              fontWeight: "600",
              cursor: "pointer",
              fontFamily: theme.fonts.sans,
              transition: "all 0.2s ease",
            }}
          >
            Fechar
          </button>
        </div>
      </div>
    </div>
  );
}
